import React from 'react';
import _noop from 'lodash/noop';

import { CheckMark } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Checkbox, Stack, Typography } from '@lyearn/ui';
import { Image } from '@/components/Image';
import { SharedConnectionInfo } from '@/types/schema';

import { getWorkspaceIcon } from '../../utils';

function ConnectionSelector({
  connection,
  isAlreadySelected,
  isSelected,
  multiSelect,
  onClick,
  className,
}: {
  connection: SharedConnectionInfo;
  isAlreadySelected: boolean;
  isSelected: boolean;
  multiSelect: boolean;
  onClick?: () => void;
  className?: string;
}) {
  return (
    <Stack
      alignItems="center"
      className={cn('w-full border-interactive-white-hover p-16', className)}
      justifyContent="between">
      <Stack alignItems="center">
        <Image
          useImg
          alt={`${connection.workspaceName}-logo`}
          className="h-auto w-48 object-contain"
          src={getWorkspaceIcon(connection)}
        />
        <Stack className="ms-16" direction="col">
          <Typography className="mb-4" variant="body-short-01">
            {connection.workspaceName}
          </Typography>
          <Typography color="text-text-secondary" variant="body-short-02">
            {connection.workspaceURI}
          </Typography>
        </Stack>
      </Stack>
      {multiSelect ? (
        <Checkbox
          checked={isSelected || isAlreadySelected}
          className={isAlreadySelected ? 'opacity-50' : ''}
          data-attr="SELECT"
          data-id={connection.workspaceId}
          disabled={isAlreadySelected}
          inputProps={{ 'aria-label': connection.workspaceName }}
          onClick={isAlreadySelected ? _noop : onClick}
        />
      ) : null}
      {!multiSelect && isSelected ? <CheckMark className="h-24 w-24" /> : null}
    </Stack>
  );
}

export default ConnectionSelector;
